// extracted by mini-css-extract-plugin
module.exports = {"root":"view-header_root_1ODqE","button":"view-header_button_3r64H","active":"view-header_active_3FC3e","btnExport":"view-header_btnExport_3wz9J","mr":"view-header_mr_2V6ta"};